import intropic from "../../../../assets/pics/livedherebaner.png";
import livedherewordpic from "../../../../assets/pics/livedhereword.png";
import InfiniteScrollBanner from "./InfiniteScrollBanner";
import { useTranslation } from "react-i18next";

export default function Introsection({ data }) {
  const { t } = useTranslation();
  return (
    <div className="bg-white bg-re-200 h-fit  w-full">
      <div className="h-[200px] md:h-4/6 relative w-full ">
        <img
          src={intropic}
          className="h-full w-full"
          alt="lived here intro pic"
        />

        <img
          src={livedherewordpic}
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-26 h-4/6 w-4/6  sm:w-3/4 md:h-5/6 md:w-2/4 lg:h-5/6 lg:w-2/4"
          alt="lived here word logo"
        />
      </div>
      <div className="bg-white-400 h-1/6 mt-3 sm:h-[80px] md:h-[100px] lg:h-[115px]">
        <InfiniteScrollBanner data={data} />
      </div>
      <div className=" px-4 sm:px-6 md:px-1 pt-2 md:pt-0 pb-2 md:pb-0 md:py-4 lg:py-0 bg-ed-400">
        <div className="lg:text-xl xl:text-2xl font-cairo-regular text-center">
          {t("home.intro.body")}
        </div>
      </div>
    </div>
  );
}
